import { type Configuration, type PopupRequest } from '@azure/msal-browser'

// MSAL configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID as string,
    authority: 'https://login.microsoftonline.com/5e143f45-a8c5-472c-a947-0a3055c85501',
    redirectUri: '/',
    postLogoutRedirectUri: '/'
  },
  cache: {
    cacheLocation: 'localStorage', // Or "sessionStorage"
    storeAuthStateInCookie: true // Enable for better token persistence
  },
  system: {
    allowRedirectInIframe: true,
    iframeHashTimeout: 6000, // 6 seconds
    loadFrameTimeout: 0, // No timeout for iframe loading
    asyncPopups: true
  }
}

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
  scopes: ['User.Read', 'openid', 'profile'],
  redirectUri: '/'
}

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me'
}
